import styled from 'styled-components';

interface RatingStarsContainerProps {
  onMobile?: boolean;
  theme?: any;
}
const RatingStarsContainer = styled.div<RatingStarsContainerProps>`
  display: flex;
  justify-content: ${({ onMobile }) => (onMobile ? 'center' : 'normal')};
  > svg {
    margin: 0 ${({ theme }) => theme.size / 5}px;

    &:last-child {
      margin-right: 0;
    }

    &:first-child {
      margin-left: 0;
    }
  }
`;

export default RatingStarsContainer;
export { RatingStarsContainer };
